// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2sRf4","alert":"SettungsInbox_alert__1QjhB"};